import { styled } from "@mui/material/styles";
import { Dialog, Grid, IconButton, lighten, RadioGroup, Typography } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  height: "75vh",
  overflow: "auto",
  marginTop: "10px",
  padding: "15px",
});

export const Field = styled(Grid)({
  "& .MuiTextField-root": {
    width: "100%",
  },
});

export const Label = styled(Typography)(({ theme }) => ({
  // color: theme.palette.secondary.light,
}));

export const DescriptionBlockContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  width: "100%",
  gap: "5px",
}));

export const DescriptionLabelContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const DescriptionContainer = styled(Grid)({
  width: "100%",
  position: "relative",
});

export const SmallLabel = styled(Typography)(({ theme }) => ({
  fontSize: "10px",
  color: theme.palette.secondary.light,
  position: "absolute",
  top: "-10px",
  left: "10px",
  padding: "3px",
  backgroundColor: theme.palette.background.default,
}));

export const RecordedAudioContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  position: "relative",
  gap: "10px",
  border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderRadius: "8px",
  flexDirection: "column",
  alignItems: "flex-end",
  width: "370px",
  "& audio": {
    height: "35px",
    "&::-webkit-media-controls-enclosure": {
      borderRadius: "5px",
    },
  },
}));

export const RecordedAudioList = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  padding: "5px",
}));

export const SingleRecordedAudioContainer = styled(Grid)({
  display: "flex",
  width: "100%",
  // justifyContent : "center",
  alignItems: "center",
  "&:hover": {
    "& .MuiIconButton-root": {
      width: "40px",
      // height : "20px"
    },
  },
});

export const ReportTypeContainer = styled(RadioGroup)(({ theme }) => ({
  display: "flex",
  flexFlow: "row nowrap",
  "& >.MuiGrid-root": {
    width: "50%",
    padding: "10px",
    border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    "&:first-of-type": {
      borderRadius: "8px 0px 0px 8px",
    },
    "&:last-of-type": {
      borderRadius: "0px 8px 8px 0px",
    },
    "& >.MuiFormControlLabel-root": {
      alignItems: "start",
      height: "50px",
      "& >span": {
        padding: "0px 5px",
      },
    },
  },
}));

export const AddressedToContainer = styled(Grid)({
  display: "flex",
  justifyContent: "center",
});

export const AddressToField = styled(Grid)(({ theme }) => ({
  display: "flex",
  width: "calc(100% / 3)",
  // border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  padding: "5px 8px",
  justifyContent: "center",
  alignItems: "center",
  color: theme.palette.secondary.light,
  "&:nth-of-type(1)": {
    borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,

    // borderRadius: "8px 0px 0px 8px",
    "& >svg": {
      width: "30px",
      height: "30px",
    },
  },
  "&:nth-of-type(2)": {
    borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    "& >svg": {
      width: "25px",
      height: "25px",
    },
  },
  "&:nth-of-type(3)": {
    // borderRadius: "0px 8px 8px 0px",
    "& >svg": {
      width: "56px",
      height: "56px",
    },
  },
}));

export const UploadFilesContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderRadius: "8px",
  width: "100px",
  alignItems: "flex-end",
  position: "relative",
}));

export const UploadedFilesContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  // border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
}));

export const SingleUploadedFile = styled(Grid)(({ theme }) => ({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  // position: "relative",
  padding: "3px",
  borderRadius: "5px",
  alignItems: "center",
  "&:hover": {
    "& .MuiIconButton-root:nth-of-type(2)": {
      width: "20px",
      // height : "20px"
    },
  },
}));

export const DeleteFileButton = styled(IconButton)(({ theme }) => ({
  width: 0,
  // position: "absolute",
  // top: 0,
  // right: 0,
  height: "25px",
  overflow: "hidden",
  transition: "all 0.2s ease-in-out",
}));

export const DragNDropContainer = styled(Grid)({
  // width: "50%",
});

export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});
